// extracted by mini-css-extract-plugin
module.exports = {"tagComponent":"Tag_tagComponent__SUCBx","materialOverride":"Tag_materialOverride__mG8Jk"};